import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Award, Flame, Sparkles } from "lucide-react";
import { api } from "@/lib/api";

export function WeeklyAwards() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/awards/weekly").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d || ((d.kindest || []).length === 0 && (d.streaks || []).length === 0)) return null;
  return (
    <div className="rounded-2xl border border-brand/30 bg-gradient-to-br from-brand/10 to-transparent p-4 mt-6" data-testid="weekly-awards">
      <div className="flex items-center gap-2 mb-2"><Award size={16} className="text-brand" /><h3 className="font-serif text-lg">This week we celebrate</h3><span className="text-[11px] text-sec">🙏 one family</span></div>
      <div className="grid sm:grid-cols-2 gap-3">
        {(d.kindest || []).length > 0 && (
          <div>
            <div className="text-[11px] uppercase tracking-widest text-brand flex items-center gap-1 mb-1"><Sparkles size={11} /> Kindest souls</div>
            {d.kindest.map((m) => (
              <Link key={m.user_id} to={`/u/${m.user_id}`} data-testid={`award-kind-${m.user_id}`} className="flex items-center justify-between text-sm py-0.5 hover:text-brand">
                <span className="truncate">{m.name}</span><span className="text-brand text-xs">{m.kindness}%</span>
              </Link>
            ))}
          </div>
        )}
        {(d.streaks || []).length > 0 && (
          <div>
            <div className="text-[11px] uppercase tracking-widest text-orange-400 flex items-center gap-1 mb-1"><Flame size={11} /> Longest streaks</div>
            {d.streaks.map((m) => (
              <Link key={m.user_id} to={`/u/${m.user_id}`} data-testid={`award-streak-${m.user_id}`} className="flex items-center justify-between text-sm py-0.5 hover:text-brand">
                <span className="truncate">{m.name}</span><span className="text-orange-400 text-xs flex items-center gap-0.5"><Flame size={11} />{m.streak}d</span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default WeeklyAwards;
